var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { shallowEqual, useSelector } from 'react-redux';
import ErrorBoundary from 'syf-component-library/ui/templates/ErrorBoundary';
import { ALERTS_CATEGORIES, PAY_LATER_PRODUCT_TYPE, TEXT_ALERTS_TERMS_AND_CONDITIONS } from '../../../const/alertsConfig';
import SyfStorage from '../../../helpers/SyfStorage';
import { getAlertsData } from '../../../redux/selectors';
import { AlertCategoryTitle, ErrorInfoWrapper } from '../../atoms';
import { useAlerts } from '../../customHooks';
import AlertsSkeletonLoader from '../../molecules/AlertsSkeletonLoader';
import AlertItem from '../AlertItem';
import SecurityAlerts from '../SecurityAlerts';
import { AlertSmsTermsAndCondition, AlertTermsLink, AlertsListWrapper, CustomCard, SecurityAlertsContainer } from './subcomponents';
import onRuntimeError from '../../../helpers/runtimeError';
var AlertList = function (_a) {
    var _b, _c, _d, _e;
    var hasAlerts = _a.hasAlerts;
    var _f = useAlerts(), accountsInfo = _f.accountsInfo, syfIdentifier = _f.syfIdentifier, appConfig = _f.appConfig;
    var currentIndex = accountsInfo === null || accountsInfo === void 0 ? void 0 : accountsInfo.findIndex(function (account) { return account.accountId === syfIdentifier; });
    var productType = (_c = (_b = accountsInfo === null || accountsInfo === void 0 ? void 0 : accountsInfo[currentIndex]) === null || _b === void 0 ? void 0 : _b.product) === null || _c === void 0 ? void 0 : _c.type;
    var hideSecurityAlerts = PAY_LATER_PRODUCT_TYPE.includes(productType);
    var t = useTranslation().t;
    var allAlertIds = useSelector(getAlertsData, shallowEqual).allIds;
    var getAlertItem = useCallback(function (alertID) {
        return (_jsx(ErrorBoundary, __assign({ fallback: _jsx(ErrorInfoWrapper, { errorBody: t('errorPage.default'), errorTitle: t('errorPage.title') }), errorCallback: onRuntimeError }, { children: _jsx(AlertItem, { "data-test": "AlertItem", alertID: alertID }) }), "".concat(alertID)));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var getAlertsForCategory = function (keyname) {
        return ALERTS_CATEGORIES[keyname].filter(function (categoryAlertId) {
            return allAlertIds.includes(categoryAlertId);
        });
    };
    var currentLanguage = SyfStorage.getLanguage();
    var ASSET_HOST = (_e = (_d = appConfig === null || appConfig === void 0 ? void 0 : appConfig.config) === null || _d === void 0 ? void 0 : _d.hosts) === null || _e === void 0 ? void 0 : _e.assets;
    var termsConditionsHtmlPath = currentLanguage === 'es'
        ? TEXT_ALERTS_TERMS_AND_CONDITIONS.ES || ''
        : TEXT_ALERTS_TERMS_AND_CONDITIONS.EN || '';
    return (_jsxs(AlertsListWrapper, __assign({ "data-test": "AlertsListWrapper" }, { children: [Object.keys(ALERTS_CATEGORIES).map(function (keyname) {
                return hasAlerts ? (getAlertsForCategory(keyname).length > 0 && (_jsxs(CustomCard, __assign({ "data-test": "CustomCard" }, { children: [_jsx(AlertCategoryTitle, { "data-test": "AlertCategoryTitle", categoryKey: keyname }), getAlertsForCategory(keyname).map(function (alertID) {
                            return getAlertItem(alertID);
                        })] }), keyname))) : (_jsxs(CustomCard, __assign({ "data-test": "CustomCard" }, { children: [_jsx(AlertsSkeletonLoader, {}), ALERTS_CATEGORIES[keyname]
                            // only load alerts we have preference data for. otherwise will always show skeleton
                            .filter(function (categoryAlertId) {
                            return allAlertIds.includes(categoryAlertId);
                        })
                            .map(function (alertID) { return getAlertItem(alertID); })] }), keyname));
            }), !hideSecurityAlerts && (_jsx(SecurityAlertsContainer, __assign({ "data-test": "SecurityAlertsContainer" }, { children: hasAlerts ? (_jsxs(_Fragment, { children: [_jsx(AlertCategoryTitle, { "data-test": "AlertCategoryTitle", categoryKey: "securityAlerts" }), _jsx(SecurityAlerts, {})] })) : (_jsx(AlertsSkeletonLoader, { bodyCount: 2 })) }))), hasAlerts ? (_jsxs(AlertSmsTermsAndCondition, __assign({ "data-test": "AlertSmsTermsAndConditionLink" }, { children: [t('smsTermsAndConditionLink.termsAndConditionText'), _jsx(AlertTermsLink, __assign({ isInline: true, target: "_blank", href: ASSET_HOST + termsConditionsHtmlPath }, { children: t('smsTermsAndConditionLink.termsAndConditionLink') }))] }))) : null] })));
};
export default AlertList;
